import React from "react";
import { Tooltip } from "antd";

interface PropsInterface {
  icon: React.FC;
  text: string | number | undefined;
  tooltip?: string;
}

const IconText = ({ icon, text, tooltip }: PropsInterface) => (
  <Tooltip title={tooltip}>
    <span className='v-icon-text'>{React.createElement(icon)} {text}</span>
  </Tooltip>
);

export default IconText;
